import { render, staticRenderFns } from "./TeacherManager.vue?vue&type=template&id=2d5cf77a&scoped=true&"
import script from "./TeacherManager.vue?vue&type=script&lang=js&"
export * from "./TeacherManager.vue?vue&type=script&lang=js&"
import style0 from "./TeacherManager.vue?vue&type=style&index=0&id=2d5cf77a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5cf77a",
  null
  
)

export default component.exports